module.exports = __webpack_public_path__ + "static/media/wanderland.e617a3f7.png";